<section id="breadcrumb" class="breadcrumb bg-color-white text-color-dark">
	<div class="wrapper">
		<div class="breadcrumb__text">
			<strong class="home-page"><a href="./">WWW</a> / </strong>
			<a class="current-page" href="{{ breadCrumbData.parent_slug }}" *ngIf="breadCrumbData?.current_page?.title != breadCrumbData.parent">{{ breadCrumbData.parent }} {{ breadCrumbChildLength > 1 ? '/' : ''}} </a>
			<span class="current-page" [attr.data-id]="breadCrumbData.parent_id" [attr.data-slug]="breadCrumbData.parent_slug" *ngIf="breadCrumbData?.current_page?.title == breadCrumbData.parent">{{ breadCrumbData.parent }} {{ breadCrumbChildLength > 1 ? '/' : ''}} </span>

			<div ngbDropdown class="d-inline-block">
				<button class="btn btn-outline-primary" id="breadcrumbDropdown" ngbDropdownToggle *ngIf="breadCrumbData?.current_page?.title != '' && breadCrumbData.children && breadCrumbChildLength > 1">{{ breadCrumbData?.current_page?.title }}<span><i class="icon-breadcrumb-bottom"></i></span></button>

				<div ngbDropdownMenu aria-labelledby="breadcrumbDropdown" *ngIf="breadCrumbData.children && breadCrumbChildLength > 1">
					<button ngbDropdownItem *ngFor="let bcVal of breadCrumbData.children" class="{{ breadCrumbData?.current_page?.link == bcVal.link ? 'dropdown-item active-menu' : 'dropdown-item' }}">
						<a routerLink="/{{ bcVal.link }}" (click)="addMenuId( bcVal.id )" [innerHtml]="bcVal.title"></a>
					</button>
				</div>
			</div>
		</div>
	</div>
</section>